"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BANNER_LOCATION = exports.BANNER_CTA_TYPE = exports.BANNER_TYPE = exports.BANNER_COLLECTION_NAME_SUPER = exports.BANNER_COLLECTION_NAME = void 0;
exports.BANNER_COLLECTION_NAME = "banners";
exports.BANNER_COLLECTION_NAME_SUPER = "banners_super";
var BANNER_TYPE;
(function (BANNER_TYPE) {
    BANNER_TYPE["PROMOTIONAL"] = "PROMOTIONAL";
    BANNER_TYPE["SALES"] = "SALES";
    BANNER_TYPE["MISCELLANEOUS"] = "MISCELLANEOUS";
})(BANNER_TYPE = exports.BANNER_TYPE || (exports.BANNER_TYPE = {}));
var BANNER_CTA_TYPE;
(function (BANNER_CTA_TYPE) {
    BANNER_CTA_TYPE["IN_APP"] = "IN_APP";
    BANNER_CTA_TYPE["DEEP_LINK"] = "DEEP_LINK";
    BANNER_CTA_TYPE["WEBVIEW_LINK"] = "WEBVIEW_LINK";
    BANNER_CTA_TYPE["EXTERNAL_LINK"] = "EXTERNAL_LINK";
})(BANNER_CTA_TYPE = exports.BANNER_CTA_TYPE || (exports.BANNER_CTA_TYPE = {}));
var BANNER_LOCATION;
(function (BANNER_LOCATION) {
    BANNER_LOCATION["HOME_SCREEN"] = "HOME_SCREEN";
    BANNER_LOCATION["WALLET"] = "WALLET";
    BANNER_LOCATION["REFERRAL"] = "REFERRAL";
})(BANNER_LOCATION = exports.BANNER_LOCATION || (exports.BANNER_LOCATION = {}));
//# sourceMappingURL=banner.model.js.map